import React, { useState } from 'react';
import resumePdf from '../assets/resume.pdf';

function Resume() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleView = () => {
        const newTab = window.open('', '_blank');
        if (newTab) {
            newTab.document.write(`
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <title>Arabella Resaba - Resume Viewer</title>
                    <style>
                        body { margin: 0; padding: 0; background-color: #525659; display: flex; flex-direction: column; height: 100vh; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
                        .toolbar { background-color: #323639; padding: 12px 20px; display: flex; justify-content: flex-end; align-items: center; box-shadow: 0 1px 3px rgba(0,0,0,0.3); z-index: 10; gap: 12px; }
                        h1 { color: #fff; font-size: 16px; margin: 0; flex: 1; font-weight: 500; }
                        .action-btn { border: none; padding: 8px 20px; border-radius: 4px; font-weight: 600; font-size: 14px; cursor: pointer; transition: background 0.2s; display: flex; align-items: center; gap: 8px; }
                        .download-btn { background-color: #8ab4f8; color: #202124; }
                        .download-btn:hover { background-color: #aecbfa; }
                        .print-btn { background-color: #f1f3f4; color: #202124; }
                        .print-btn:hover { background-color: #e8eaed; }
                        iframe { flex: 1; border: none; width: 100%; height: 100%; }
                    </style>
                </head>
                <body>
                    <div class="toolbar">
                        <h1>Arabella Resaba - Resume Viewer</h1>
                        <button class="action-btn print-btn" onclick="printPDF()" title="Print Resume">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/>
                            </svg>
                            Print
                        </button>
                        <button class="action-btn download-btn" onclick="downloadPDF()" title="Download Resume">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                            </svg>
                            Download PDF
                        </button>
                    </div>
                    <iframe id="resumeIframe" src="${resumePdf}#toolbar=0" title="Resume"></iframe>
                    <script>
                        function downloadPDF() {
                            const a = document.createElement('a');
                            a.href = '${resumePdf}';
                            a.download = 'Arabella_Resaba_Resume.pdf';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                        function printPDF() {
                            const iframe = document.getElementById('resumeIframe');
                            if (iframe.contentWindow) {
                                iframe.contentWindow.focus();
                                iframe.contentWindow.print();
                            }
                        }
                    </script>
                </body>
                </html>
            `);
            newTab.document.close();
        }
    };

    const handleDownloadClick = () => {
        setIsModalOpen(true);
    };

    const confirmDownload = () => {
        setIsModalOpen(false);
        const link = document.createElement('a');
        link.href = resumePdf;
        link.download = 'Arabella_Resaba_Resume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <section id="resume" className="resume-section" style={{ background: "transparent", textAlign: "center", padding: "80px 20px", position: 'relative' }}>
            <h2 className="section-title">Resume</h2>
            <p style={{ color: "var(--text-dark)", marginBottom: "30px", fontSize: "15px", opacity: 0.8 }}>
                Download my full resume to learn more about my background, skills, and experiences.
            </p>
            <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
                <button className="btn-primary" style={{ padding: "12px 28px", cursor: 'pointer' }} onClick={handleView}>
                    View Resume
                </button>
                <button className="btn-outline" style={{ padding: "12px 28px", cursor: 'pointer' }} onClick={handleDownloadClick}>
                    Download PDF
                </button>
            </div>

            {/* Custom Confirmation Modal */}
            {isModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2000,
                    backdropFilter: 'blur(4px)'
                }}>
                    <div style={{
                        backgroundColor: 'var(--white)',
                        padding: '30px',
                        borderRadius: '12px',
                        maxWidth: '400px',
                        textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                        fontFamily: 'inherit',
                        border: '1px solid var(--border-ozone)'
                    }}>
                        <h3 style={{ margin: '0 0 15px', color: 'var(--text-dark)' }}>Download Resume?</h3>
                        <p style={{ margin: '0 0 25px', color: 'var(--text-muted)', fontSize: '14px' }}>
                            Are you sure you want to download the PDF version of my resume?
                        </p>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                             <button 
                                onClick={() => setIsModalOpen(false)}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid var(--border-ozone)',
                                    backgroundColor: 'transparent',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    color: 'var(--text-dark)'
                                }}
                            >
                                Cancel
                            </button>
                            <button 
                                onClick={confirmDownload}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid var(--ozone)',
                                    backgroundColor: 'var(--ozone)',
                                    color: 'var(--glaze)',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                Yes, Download
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default Resume;
